<template>
  <div class="submitted-deals">
    <div class="filterBox">
      <div class="filter" ref="operationRef">
        <div class="filter-item">
          <div class="filter-item-label">Time</div>
          <div class="filter-item-input">
               <artemisads-range-picker
              :allowClear="true"
              v-model:value="filter.time"
              :presets="RANGE_PRESETS"
              :getPopupContainer="() => $refs.operationRef"
            />
          </div>
        </div>
        <div class="filter-item" ref="brandRef">
          <div class="filter-item-label">Brand</div>
          <div class="filter-item-input">
            <artmisads-input
              v-model:value="filter.brandName"
              placeholder="Brand"
            />
          <!-- <artmisads-select show-search v-model:value="filter.brandName" style="width: 232px" :options="brandOptions"
          @search="searchBrand" :show-arrow="false" :filter-option="false" :not-found-content="null" placeholder="All"
          allowClear  :getPopupContainer="() => $refs.brandRef"/> -->
          </div>
        </div>
        <div class="filter-item">
          <div class="filter-item-label">Content</div>
          <div class="filter-item-input">
            <artmisads-input
              v-model:value="filter.dealContent"
              placeholder="Content"
            />
          </div>
        </div>
          <div class="filter-item">
          <div class="filter-item-label">SDID</div>
          <div class="filter-item-input">
            <artmisads-input
              v-model:value="filter.dmSubmittedDealId"
              placeholder="SDID"
            />
          </div>
        </div>
       <div class="filter-item">
          <div class="filter-item-label">ASIN</div>
          <div class="filter-item-input">
            <artmisads-input
              v-model:value="filter.asin"
              placeholder="ASIN"
            />
          </div>
        </div>
      </div>
      <div class="btn-box">
        <artmisads-button type="primary" @click="handleReset"
          >Reset</artmisads-button
        >
        <artmisads-button type="primary" @click="handleSearch"
          >Search</artmisads-button
        >
      </div>
    </div>
    <div class="table-data" >
      <div ref="mainRef" class="top" >
        <a-dropdown :getPopupContainer="() => $refs.mainRef">
            <template #overlay>
              <artmisads-dropdown-menu @click="handleExportClick">
                <a-menu-item key="all">Export All Data</a-menu-item>
                <a-menu-item key="filter">Export with Filters</a-menu-item>
              </artmisads-dropdown-menu>
            </template>
            <artmisads-button-special class="export-btn">
              <svg class="icon daochu" aria-hidden="true">
                <use xlink:href="#icon-daochu"></use>
              </svg>
              <span class="btn-text">Export</span>
              <svg class="icon artmisads-select-down-icon" aria-hidden="true">
                <use xlink:href="#icon-jiantou-xia-cu"></use>
              </svg>
            </artmisads-button-special>
          </a-dropdown>
      </div>
     
      <artmisads-table
        :pagination="param"
        :columns="columns"
        :data-source="data"
        :change="onTableChange"
        :loading="load"
        :scroll="{  y: tableScrollHeight }"
      >
        <template #bodyCell="{ column, text, index, record }">
          <template v-if="column.key === 'dealContent'">
             <a-tooltip placement="top">
        <template #title>
          <span>{{ record.dealContent }}</span>
        </template>
        <div class="content">
        {{ record.dealContent || '--' }}

        </div>
      </a-tooltip>
        
          </template>

          <template v-if="column.key === 'time'">
            {{
              record.submitTime
                ? moment(record.submitTime).format('YYYY-MM-DD HH:mm:ss')
                : '--'
            }}
          </template>
          <template v-if="column.key === 'action'">
            <a @click="handleView(record)">
              view
            </a>
          </template>
        </template>
      </artmisads-table>
    </div>
  </div>
</template>
<script setup>
import { AMAZON_CURRENCY_MAPPER } from '~/contants/common'
import { ref,  } from 'vue'
import { publisherAdminApi } from '~/server/index'
import { RANGE_PRESETS } from '~/contants/reports'
import { useTableScrollHeight } from '@/utils/useTableScrollHeight'
import moment from 'moment'
const param = ref({
  current: 1,
  pageSize: 10,
  total: 0,
})

const asins = ref('')
const startCreateTimestamp = ref('')
const endCreateTimestamp = ref('')
const filter = ref({
 time:'',
brandName:"",
dealContent:"",
dmSubmittedDealId:""
})
const columns = ref([
  {
    title: 'Time',
    dataIndex: 'time',
    key: 'time',
 
  },
  {
    title: 'Brand',
    dataIndex: 'brandName',
    key: 'brandName',
  
  },
  {
    title: 'Asin',
    dataIndex: 'asin',
    key: 'asin',
  },
   {
    title: 'Category',
    dataIndex: 'artemisCategory',
    key: 'artemisCategory',
  
  },
  {
    title: 'Title',
    dataIndex: 'title',
    key: 'title',
  
  },
  {
    title: 'Content',
    dataIndex: 'dealContent',
    key: 'dealContent',

  },
  {
    title: 'SDID',
    dataIndex: 'dmSubmittedDealId',
    key: 'dmSubmittedDealId',
  },
  {
    title:'Action',
    dataIndex:'action',
    key:'action'
  }
 
])
const data = ref([])
const load = ref(false)

const { tableScrollHeight } = useTableScrollHeight({
  selector: '.table-data',
  bottomSpace: 155,
  minHeight: 200,
  maxHeight: 800,
  defaultHeight: 350,
})
const handleReset = () => {
  filter.value = {
   time:'',
brandName:"",
dealContent:"",
dmSubmittedDealId:""
  }
  param.value.current=1
  startCreateTimestamp.value = ''
  endCreateTimestamp.value = ''

  getLsit()
}
const handleSearch = () => {
  if (filter.value.time.length) {
    startCreateTimestamp.value = moment(filter.value.time[0])
      .startOf('day')
      .valueOf()
    endCreateTimestamp.value = moment(filter.value.time[1])
      .startOf('day')
      .valueOf()
  }
 
  param.value.current=1
  getLsit()
}
const onTableChange = (pagination) => {
  param.value.current = pagination.current
  param.value.pageSize = pagination.pageSize
  getLsit()
}
const getLsit = async () => {
  load.value = true
  const res = await publisherAdminApi.getSubmittedDeals({
    page: param.value.current,
    size: param.value.pageSize,
    startSubmitTimestamp: startCreateTimestamp.value,
    endSubmitTimestamp: endCreateTimestamp.value,
    asins: asins.value.value,
    ...filter.value,
  })
  load.value = false
  if (res.success) {
    data.value = res.data.data
    param.value.total = res.data.total
  }
}
const handleView = (record) => {
  window.open(record.previewUrl)
}
 const handleExportClick = async ({ key }) => {
    let exportParams = {
      endReportDatePstTimestamp: moment().endOf('day').valueOf(),
      startReportDatePstTimestamp: moment().subtract(180, 'day').startOf('day').valueOf(),
    }, newExportParams = {};
    if (key === 'filter') {
       const startCreateTimestamp = moment(filter.value.time[0])
      .startOf('day')
      .valueOf()
       const endCreateTimestamp = moment(filter.value.time[1])
      .startOf('day')
      .valueOf()
      exportParams = { 
        startSubmitTimestamp: startCreateTimestamp,
        endSubmitTimestamp: endCreateTimestamp,
        asins: asins.value.value,
        ...filter.value,
      }
    }

    for(let item in exportParams) {
      if (exportParams[item]) {
        newExportParams[item] = exportParams[item];
      }
    }
    const finalParams = {
      qs: newExportParams,
      fileName: `Commissions-${moment().format('YYYY-MM-DD')}.csv`,
      platform:'operator'
    }
    publisherAdminApi.dmSubmittedDealsExport(finalParams);
  }
getLsit()
</script>
<style scoped lang="less">
  .top{
    display: flex;
    justify-content: flex-end;
    margin-bottom: 16px;
  }
  .content{
    width: 180px;
display: -webkit-box;
  -webkit-line-clamp: 3; /* 限制行数为3 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  
  }
.submitted-deals {
  padding: 16px;

  width: 100%;
}
.table-data {

  border-radius: 8px;
  border: 1px solid #fff;
  border-radius: 12px;
  overflow: hidden;
  border-radius: 12px;
  background-color: var(--color-white);
  padding: 15px;

}
.filterBox {
  padding: 15px 16px;
  margin: 16px 0;
  flex-wrap: wrap;
  border-radius: 8px;
  background: #fff;
}
.btn-box {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 20px;
}
.filter {
  display: flex;
  gap: 22px;
  flex-wrap: wrap;
  .filter-item {
    display: flex;
    gap: 10px;
    align-items: center;
    .label {
      color: #0f0629;
      font-family: 'Sora';
      font-size: 14px;
      font-style: normal;
      font-weight: 500;

      opacity: 0.9;
    }
  }
}
</style>
